module.exports = __webpack_public_path__ + "media/images/weather/311_night-01d3acd68b2ee3db3c86f4832d3d8452.png";